//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// component
import Header from "../../component/common/Header";
import SearchResult from "./components/SearchResult";
import Footer from "../../component/common/Footer";
import InnerCon from "../../component/layouts/InnerCon";

export default function SearchResultPage() {
    return (
        <>
            <Wrap>
                <Header />
                <InnerCon>
                    <SearchResult />
                </InnerCon>
                <Footer />
            </Wrap>
        </>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;
`;
